import React from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import { AlertLevels } from '@/constants/enums';
import SeverityIcon from '@/comp/common/icons/SeverityIcon';

const Severity = observer(({ alertRule: { severity } }) => {
  const { t } = useTranslation();

  if (typeof severity !== 'string') {
    return <span className="rule-item-severity"></span>;
  }

  switch (severity) {
    case AlertLevels.Shutdown:
      return (
        <div className="rule-item-severity">
          <span className="severity-icon">
            <SeverityIcon severity={AlertLevels.Shutdown} />
          </span>
          <span className="severity-label">{t('Shutdown')}</span>
        </div>
      );
    case AlertLevels.Warning:
      return (
        <div className="rule-item-severity">
          <span className="severity-icon">
            <SeverityIcon severity={AlertLevels.Warning} />
          </span>
          <span className="severity-label">{t('Warning')}</span>
        </div>
      );
    case AlertLevels.Service:
      return (
        <div className="rule-item-severity">
          <span className="severity-icon">
            <SeverityIcon severity={AlertLevels.Service} />
          </span>
          <span className="severity-label">{t('Service')}</span>
        </div>
      );
    default:
      return <span className="rule-item-severity"></span>;
  }
});

export default Severity;
